import React from 'react';
import { Group, Stack, Text, Title } from '@mantine/core';
import useIsMounted from '@hooks/use-is-mounted';
import { IconMoonStars } from '@tabler/icons';
import useStyles from './MinimumNightsBadge.styles';
import { usePropertyState } from "@core/providers/PropertyStateProvider";


export const MinimumNightsBadge: React.FC = () => {

    const { classes } = useStyles();
    const isMounted = useIsMounted();

    const { propertyDetailsData } = usePropertyState();


    return isMounted && (

        <Group className={classes.nightBadgeBooking}>
            <Stack spacing={0}>
                <Title className={classes.minBadgeTitle} order={1}>Min Booking</Title>

                <Text className={classes.minBadgeText}>

                    {propertyDetailsData?.settings?.minimumNights}

                    <IconMoonStars className={classes.icon} stroke={1}/>

                    {/*<span>{formatTitleNoS(propertyDetailsData?.settings?.minimumNights, 'Nights')}</span>*/}

                </Text>
            </Stack>

        </Group>

    )

}
